//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import * as collectionsApi from '@apis/collections/collectionsApi';
import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { ICuralateStore } from '@models/AppState';
import { getStreamsDrawerActions } from '@react-bridge/wrappers/ng-service-provider';
import { closeStreamDeleteConfirmationModal } from '@streams-drawer/actions/streams-drawer-actions';
import { IStream } from '@streams-drawer/model/IStream';
import { StreamsDrawerActionNames } from '@streams-drawer/model/StreamsDrawerActionNames';
import { ISetStreamsAction } from '@streams/actions/streamDrawerActions';
import * as streamDeleteActions from '@streams/reducers/streamDeleteSlice';
import { alphabetizeLocaleCompare } from '@utils/arrayUtils';
import { getRequestErrorMessage } from '@utils/getRequestErrorMessage';

import { ReduxDispatch } from 'app/curalate.store';

export const streamDeletionActions = {
  deleteStream:
    () => async (dispatch: ReduxDispatch, getState: () => ICuralateStore) => {
      dispatch(streamDeleteActions.requestDeleteStream());
      try {
        const streamId = getState().streams.streamsDrawer.selectedStream.id;

        const response = await collectionsApi.deleteStream(streamId);
        const streamsAll = await collectionsApi.getStreams();
        const streams = alphabetizeLocaleCompare(
          streamsAll,
          (stream) => stream.name,
        );
        const selStr = streamsAll[0];
        const setStreamsAction: ISetStreamsAction = {
          type: StreamsDrawerActionNames.SET_STREAMS,
          streams,
        };
        dispatch(setStreamsAction);

        // Forces reload of stream and filters. Required for both new stream creation, deletion and stream update actions to effect the content grid
        dispatch(
          getStreamsDrawerActions().selectStream(selStr as IStream, true),
        );
        dispatch(closeStreamDeleteConfirmationModal());
        dispatch(streamDeleteActions.deleteStreamSucceeded());
        dispatch(
          toastNotificationsActions.addToastNotification({
            title: 'Success!',
            message: 'Stream deleted successfully.',
            type: ToastType.SUCCESS,
          }),
        );
      } catch (error) {
        let deleteStreamError = '';
        const err = getRequestErrorMessage(error);

        if (err) {
          deleteStreamError = `Error deleting the stream. Please try again`;
        }
        dispatch(closeStreamDeleteConfirmationModal());
        dispatch(streamDeleteActions.deleteStreamFailed());
        dispatch(
          toastNotificationsActions.addToastNotification({
            title: 'Error!',
            message: deleteStreamError,
            type: ToastType.ERROR,
          }),
        );
      }
    },
};
